export function useFlags() {
  return {
    stripe: true,
  };
}
